import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'
/*import blog1 from '../../assets/images/blog/blog-img1.jpg'
import blog5 from '../../assets/images/blog/blog-img5.jpg'
import blog6 from '../../assets/images/blog/blog-img6.jpg'*/
import user1 from '../../assets/images/user1.jpg'
/*import user2 from '../../assets/images/user2.jpg'
import user3 from '../../assets/images/user3.jpg'*/

const OurBlog = () => {
  const { ourBlog } = useStaticQuery(
    graphql`
      query {
        ourBlog: allContentfulBlogPost(
          limit: 3
          sort: { order: DESC, fields: createdAt }
        ) {
          edges {
            node {
              slug
              title
              createdAt(formatString: "DD MMMM YYYY")
              featured {
                fluid(maxWidth: 750) {
                  srcWebp
                }
              }
            }
          }
        }
      }
    `
  )

  return (
    <section className="blog-area pt-100 pb-70 bg-fffbf5">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="blog" />
            Our Blog
          </span>
          <h2>Latest Valuable Insights</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p>
        </div>

        <div className="row">
          {ourBlog &&
            ourBlog.edges.map((blog, index) => {
              const cls =
                index === 2
                  ? 'col-lg-4 col-md-6 offset-lg-0 offset-md-3'
                  : 'col-lg-4 col-sm-6'
              return (
                <div key={index} className={cls}>
                  <div className="single-blog-post">
                    <div className="post-image">
                      <Link to={`/` + blog.node.slug}>
                        <img
                          src={blog.node.featured.fluid.srcWebp}
                          alt={blog.node.title}
                        />
                      </Link>
                    </div>

                    <div className="post-content">
                      <ul className="post-meta d-flex justify-content-between align-items-center">
                        <li>
                          <div className="post-author d-flex align-items-center">
                            <img
                              src={user1}
                              className="rounded-circle"
                              alt="Sirichai"
                            />
                            <span>Sirichai</span>
                          </div>
                        </li>
                        <li>
                          <i className="flaticon-calendar"></i>{' '}
                          {blog.node.createdAt}
                        </li>
                      </ul>
                      <h3>
                        <Link to={`/` + blog.node.slug}>{blog.node.title}</Link>
                      </h3>
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </section>
  )
}

export default OurBlog
